import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto space-y-8 sm:space-y-16" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-2xl flex flex-col gap-4"
}
const _hoisted_3 = {
  key: 1,
  class: "grid grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8"
}
const _hoisted_4 = {
  key: 1,
  class: "w-full aspect-[4/3] rounded-lg overflow-hidden"
}

import { computed, ref } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { MediaType, PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";

// Import shared components
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Image from "@/views/blocks/shared/section/media/image/Image.vue";
import Media from "@/views/blocks/shared/section/media/media/Media.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import LightboxDialog from "@/views/blocks/gallery/components/LightboxDialog.vue";
import GalleryButton from "@/views/blocks/gallery/components/GalleryButton.vue";

import type { SimpleThreeColumnsProps } from "./SimpleThreeColumnsProps";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleThreeColumns',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

// Lightbox state
const selectedImage = ref<{ src: string; alt: string } | null>(null);
const lightboxDialog = ref<InstanceType<typeof LightboxDialog> | null>(null);

// Lightbox methods
const openLightbox = (image: { src: string; alt: string }) => {
    selectedImage.value = image;
    lightboxDialog.value?.openLightbox();
};

const closeLightbox = () => {
    selectedImage.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (
                        !dataValues.value.tag.isHidden ||
                        !dataValues.value.title.isHidden ||
                        !dataValues.value.description.isHidden
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!dataValues.value.tag.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 0,
                        blockId: _ctx.block.id,
                        "field-name": "tag"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Heading, {
                            text: dataValues.value.tag.data.text,
                            tag: dataValues.value.tag.data.tag,
                            "text-color": styleValues.value.brand
                          }, null, 8, ["text", "tag", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.title.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 1,
                        blockId: _ctx.block.id,
                        "field-name": "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Heading, {
                            text: dataValues.value.title.data.text,
                            tag: dataValues.value.title.data.tag,
                            "text-color": styleValues.value.text,
                            class: "text-4xl sm:text-5xl"
                          }, null, 8, ["text", "tag", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true),
                  (!dataValues.value.description.isHidden)
                    ? (_openBlock(), _createBlock(EditableElement, {
                        key: 2,
                        blockId: _ctx.block.id,
                        "field-name": "description"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Paragraph, {
                            text: dataValues.value.description.data.text,
                            "text-color": styleValues.value.text,
                            class: "text-lg opacity-70"
                          }, null, 8, ["text", "text-color"])
                        ]),
                        _: 1
                      }, 8, ["blockId"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (dataValues.value.images.data.items.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.images.data.items, (image) => {
                    return (_openBlock(), _createBlock(EditableElement, {
                      key: image.id,
                      blockId: _ctx.block.id,
                      "field-name": `images_${image.id}`,
                      hideable: false
                    }, {
                      default: _withCtx(() => [
                        (!image.mediaType || image.mediaType === _unref(MediaType).IMAGE)
                          ? (_openBlock(), _createBlock(GalleryButton, {
                              key: 0,
                              "accent-color": styleValues.value.brand,
                              "aria-label": `View ${image.alt} in lightbox`,
                              onClick: ($event: any) => (openLightbox(image))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(Image, {
                                  src: image.src,
                                  alt: image.alt,
                                  width: "401",
                                  height: "300",
                                  class: "w-full object-cover aspect-[4/3] rounded-lg"
                                }, null, 8, ["src", "alt"])
                              ]),
                              _: 2
                            }, 1032, ["accent-color", "aria-label", "onClick"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(Media, {
                                data: image,
                                "image-width": 401,
                                "image-height": 300,
                                "video-width": 401,
                                "video-height": 300
                              }, null, 8, ["data"])
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["blockId", "field-name"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(LightboxDialog, {
        ref_key: "lightboxDialog",
        ref: lightboxDialog,
        "selected-image": selectedImage.value,
        onClose: closeLightbox
      }, null, 8, ["selected-image"])
    ]),
    _: 1
  }, 8, ["id", "background-color", "scrollAnimationType"]))
}
}

})